export const textCompile = (text: string): string[] => {
  return text.split(/\n/g);
}
